import { useQuery } from '@tanstack/react-query';
import { getEvaluation } from '../../api/workEnvironmentQueries';

export const EvaluationQueryKey = 'WORK_ENVIRONMENT_EVALUATION';

export const useEvaluationQuery = (surveyId: number, language: string) =>
  useQuery({
    queryKey: [EvaluationQueryKey, surveyId, language],
    queryFn: () => getEvaluation(surveyId, language),
  });
